import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import CustomInput from '../CustomInput/CustomInput';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';

class ForcePasswordChange extends Component {
  state = {
    newPassword: '',
    confirmPassword: '',
    error: '',
  };

  handleChange = (event) => {
    this.setState({ 
      [event.target.name]: event.target.value,
      error: '',
    });
  };

  handleSubmit = () => {
    const { newPassword, confirmPassword } = this.state;
    const { onChangePassword } = this.props;

    if (!newPassword || newPassword.length < 6) {
      this.setState({ error: 'Password must be at least 6 characters' });
      return;
    }

    if (newPassword !== confirmPassword) {
      this.setState({ error: 'Passwords do not match' });
      return;
    }

    onChangePassword(newPassword, confirmPassword);
  };

  render() {
    const { open } = this.props;
    const { newPassword, confirmPassword, error } = this.state;

    return (
      <Dialog
        open={open}
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Change Password Required</DialogTitle>
        <DialogContent>
          <p style={{ marginBottom: '20px', color: '#666' }}>
            You must change your password before continuing. Please enter a new password.
          </p>
          {error && (
            <p style={{ color: '#f44336', marginBottom: '10px' }}>{error}</p>
          )}
          <GridContainer>
            <GridItem xs={12}>
              <CustomInput
                labelText="New Password"
                id="newPassword"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  type: 'password',
                  value: newPassword,
                  name: 'newPassword',
                  onChange: this.handleChange,
                  placeholder: 'Enter new password (min 6 characters)',
                }}
              />
            </GridItem>
            <GridItem xs={12}>
              <CustomInput
                labelText="Confirm New Password"
                id="confirmPassword"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  type: 'password',
                  value: confirmPassword,
                  name: 'confirmPassword',
                  onChange: this.handleChange,
                  placeholder: 'Confirm new password',
                }}
              />
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleSubmit} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ForcePasswordChange.propTypes = {
  open: PropTypes.bool.isRequired,
  onChangePassword: PropTypes.func.isRequired,
};

export default ForcePasswordChange;
